// ─── Client Portal route table ──────────────────────────────────────────
import PortalOverview from '../pages/portal/PortalOverview';
import PortalOrders from '../pages/portal/PortalOrders';
import PortalPlaceOrder from '../pages/portal/PortalPlaceOrder';
import PortalBills from '../pages/portal/PortalBills';
import PortalLedger from '../pages/portal/PortalLedger';
import PortalNotes from '../pages/portal/PortalNotes';

export const PORTAL_ROUTES = [
  { path: '',            component: PortalOverview, index: true },
  { path: 'orders',      component: PortalOrders },
  { path: 'place-order', component: PortalPlaceOrder },
  { path: 'bills',       component: PortalBills },
  { path: 'ledger',      component: PortalLedger },
  { path: 'notes',       component: PortalNotes },
];
